import React, { useEffect } from 'react';

// Privacy policy is intentionally kept in English for all language versions.
export default function PrivacyModal({ open, onClose }) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" onClick={e => e.stopPropagation()} role="dialog" aria-modal="true" aria-label="Privacy Policy">
        <button className="modal-close" onClick={onClose} aria-label="Close">✕</button>
        <h2 className="modal-title">Privacy Policy</h2>
        <div className="modal-content">
          <p><em>Last updated: 2026</em></p>

          <p>
            This privacy policy explains how the Roleplay Messages web application
            (&ldquo;the Service&rdquo;) handles your data. The Service lets you generate
            World of Warcraft roleplay texts with the help of an AI model.
          </p>

          <h3>1. Data we process</h3>
          <p>
            When you generate texts, the description and options you enter (number of
            texts, language, text type, style, character details) are transmitted to our
            server and forwarded to our AI provider to create the requested texts. We do
            not ask for and do not store any personal account data — there is no login
            and no user profile.
          </p>

          <h3>2. Processing by OpenAI</h3>
          <p>
            To generate the texts, your input is sent to <strong>OpenAI</strong>
            (OpenAI, L.L.C., USA), which processes it on our behalf via its API. This
            means your text prompts leave the EU and are processed on servers operated by
            OpenAI. Please do <strong>not</strong> enter any personal, sensitive or
            confidential information into the prompt field. OpenAI&rsquo;s handling of API
            data is described in their privacy policy at{' '}
            <a href="https://openai.com/policies/privacy-policy" target="_blank" rel="noopener noreferrer">
              openai.com/policies/privacy-policy
            </a>.
          </p>

          <h3>3. Technical data &amp; rate limiting</h3>
          <p>
            To protect the Service from abuse, your IP address is processed temporarily
            and stored for a short period (currently 30 minutes) solely to enforce a
            request limit. It is not used to identify you and is automatically discarded
            afterwards. Standard server logs may be created by our hosting provider for
            operational and security purposes.
          </p>

          <h3>4. Generated texts</h3>
          <p>
            The texts returned to you are shown in your browser and can be copied for use
            in the addon. We do not permanently store the generated texts on our server.
          </p>

          <h3>5. Cookies &amp; local storage</h3>
          <p>
            The Service does not use tracking cookies. Your selected interface language
            may be saved in your browser&rsquo;s local storage for convenience; this data
            never leaves your device.
          </p>

          <h3>6. Legal basis</h3>
          <p>
            Where the GDPR applies, processing is based on our legitimate interest
            (Art. 6(1)(f) GDPR) in providing and securing the Service, and on the
            performance of the service you request (Art. 6(1)(b) GDPR).
          </p>

          <h3>7. Your rights</h3>
          <p>
            You have the right to access, rectification, erasure and restriction of your
            personal data, as well as the right to lodge a complaint with a supervisory
            authority. As the Service does not maintain user accounts, most data is
            transient and not linked to your identity.
          </p>

          <h3>8. Contact</h3>
          <p>
            For any privacy-related questions, please contact us via the details in our{' '}
            <a href="https://www.peppertools.de/de/impressum/" target="_blank" rel="noopener noreferrer">
              imprint
            </a>.
          </p>
        </div>
      </div>
    </div>
  );
}
